import { ExportRow } from '@portal/shared/types/export.types';
import { TwoWayRequestItemListResponseDto } from '../services/request-processing.types';

export const mapRequestProcessingToExport = (request: TwoWayRequestItemListResponseDto): ExportRow => ({
  deviceId: { title: 'Device ID', value: request.deviceId },
  serialNumber: { title: 'Serial Number', value: request.serialNumber },
  commDeviceId: { title: 'Comm Device ID', value: request.commDeviceId },
  deviceType: { title: 'Device Type', value: request.deviceType },
  command: { title: 'Command', value: request.command },
  commandStatus: { title: 'Command Status', value: request.commandStatus },
  commandGroupName: { title: 'Command Group Name', value: request.actionName },
  createdOnDateTime: { title: 'Created On', value: request.createdOnDateTime },
  scheduledDateTime: { title: 'Scheduled', value: request.scheduledDateTime },
  startDateTime: { title: 'Started', value: request.startDateTime },
  completedDateTime: { title: 'Completed', value: request.completedDateTime },
  imageName: { title: 'Image Name', value: request.imageName },
  user: { title: 'User', value: request.user }
});
